(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-codex-buy-box-test]';
  var INITIALIZED_ATTR = 'data-cbb-initialized';

  function initAll(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(initSection);
  }

  function initSection(section) {
    if (!section || section.getAttribute(INITIALIZED_ATTR) === 'true') return;

    section.setAttribute(INITIALIZED_ATTR, 'true');

    applyBogoUrlParams(section);

    initToggleGroups(section);
    initVariantSelectors(section);
    initPurchaseCards(section);
    initQuantity(section);
    initGallery(section);
    initForm(section);
    initSticky(section);
  }

  function getConfig(section) {
    var configScript = section.querySelector('[data-cbb-config]');

    if (!configScript) return {};

    try {
      return JSON.parse(configScript.textContent || '{}');
    } catch (error) {
      console.error('[Codex Buy Box Test] Invalid config JSON:', error);
      return {};
    }
  }

  function applyBogoUrlParams(section) {
    var config = getConfig(section);
    var rawParams = config.bogoUrlParams;

    if (!config.bogoUrlParamsEnabled || !rawParams || !window.URL || !window.URLSearchParams || !window.history || !window.history.replaceState) {
      return false;
    }

    try {
      var currentUrl = new URL(window.location.href);
      var cleanedParams = String(rawParams).trim();
      var hashIndex = cleanedParams.indexOf('#');

      if (hashIndex > -1) {
        cleanedParams = cleanedParams.slice(0, hashIndex);
      }

      if (/^https?:\/\//i.test(cleanedParams)) {
        cleanedParams = new URL(cleanedParams).search.replace(/^\?/, '');
      } else {
        cleanedParams = cleanedParams.replace(/^[?#&]+/, '');
      }

      if (!cleanedParams) {
        return false;
      }

      var bogoParams = new URLSearchParams(cleanedParams);
      var hasChanged = false;

      bogoParams.forEach(function (value, key) {
        if (!key) return;

        if (currentUrl.searchParams.get(key) !== value) {
          currentUrl.searchParams.set(key, value);
          hasChanged = true;
        }
      });

      if (hasChanged) {
        window.history.replaceState(window.history.state, '', currentUrl.toString());
      }

      return hasChanged;
    } catch (error) {
      console.warn('[Codex Buy Box Test] Unable to apply BOGOS URL params:', error);
      return false;
    }
  }

  function buildCheckoutUrl(config) {
    var fallbackUrl = '/checkout';

    if (!window.URL || !window.URLSearchParams) {
      return fallbackUrl + window.location.search;
    }

    try {
      var currentUrl = new URL(window.location.href);
      var checkoutUrl = new URL(config.checkoutUrl || fallbackUrl, window.location.origin);

      currentUrl.searchParams.forEach(function (value, key) {
        if (!checkoutUrl.searchParams.has(key)) {
          checkoutUrl.searchParams.set(key, value);
        }
      });

      return checkoutUrl.pathname + checkoutUrl.search + checkoutUrl.hash;
    } catch (error) {
      console.warn('[Codex Buy Box Test] Unable to build checkout URL:', error);
      return fallbackUrl + window.location.search;
    }
  }

  function redirectToCheckout(config) {
    window.location.href = buildCheckoutUrl(config || {});
  }

  function initToggleGroups(section) {
    var groups = section.querySelectorAll('[data-cbb-toggle-group]');

    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cbb-toggle]');
        if (!button || !group.contains(button)) return;

        group.querySelectorAll('[data-cbb-toggle]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
      });
    });
  }

  function initVariantSelectors(section) {
    var config = getConfig(section);

    if (config.selectorSource !== 'product_options') return;

    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-cbb-option-button]'));
    var variantInput = section.querySelector('input[name="id"]');
    var status = section.querySelector('[data-cbb-status]');
    var submitButtons = Array.prototype.slice.call(section.querySelectorAll('[data-cbb-submit], [data-cbb-sticky-button]'));
    var selectedOptions = Object.assign({}, config.selectedOptions || {});
    var hasVariantOverride = Boolean(config.variantOverride);

    if (!buttons.length) return;

    buttons.forEach(function (button) {
      var position = button.getAttribute('data-cbb-option-position');
      var value = button.getAttribute('data-cbb-option-value');

      if (position && value && button.classList.contains('is-active')) {
        selectedOptions[position] = value;
      }

      button.addEventListener('click', function () {
        var group = button.closest('[data-cbb-variant-options]');
        var optionPosition = button.getAttribute('data-cbb-option-position');
        var optionValue = button.getAttribute('data-cbb-option-value');

        if (!optionPosition || !optionValue) return;

        selectedOptions[optionPosition] = optionValue;

        if (group) {
          group.querySelectorAll('[data-cbb-option-button]').forEach(function (item) {
            var isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }

        // A manual variant override is an intentional merchant escape hatch.
        // When present, it wins over product option matching and remains the cart variant.
        if (hasVariantOverride) {
          clearVariantMessage(status);
          return;
        }

        updateSelectedVariant(config, selectedOptions, variantInput, submitButtons, status);
      });
    });

    if (!hasVariantOverride) {
      updateSelectedVariant(config, selectedOptions, variantInput, submitButtons, status);
    }
  }

  function updateSelectedVariant(config, selectedOptions, variantInput, submitButtons, status) {
    var variant = findMatchingVariant(config.variants || [], selectedOptions);

    if (!variant || !variant.available) {
      if (variantInput) {
        variantInput.value = '';
      }

      setButtonsDisabled(submitButtons, true);
      setStatus(status, config.unavailableText || 'Selected option is unavailable.');
      return;
    }

    if (variantInput) {
      variantInput.value = String(variant.id);
    }

    setButtonsDisabled(submitButtons, false);
    clearVariantMessage(status);
  }

  function findMatchingVariant(variants, selectedOptions) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    return variants.find(function (variant) {
      return [1, 2, 3].every(function (position) {
        var selectedValue = selectedOptions[String(position)];

        if (!selectedValue) return true;

        return String(variant['option' + position] || '') === String(selectedValue);
      });
    }) || null;
  }

  function setButtonsDisabled(buttons, disabled) {
    buttons.forEach(function (button) {
      button.disabled = disabled;
    });
  }

  function clearVariantMessage(status) {
    if (!status) return;

    status.textContent = '';
  }

  function initPurchaseCards(section) {
    var cards = section.querySelectorAll('[data-cbb-purchase]');
    var sellingPlanInput = section.querySelector('[data-cbb-selling-plan-input]');
    var onetimeDetails = section.querySelector('[data-cbb-onetime-details]');
    var subscriptionDetails = section.querySelector('[data-cbb-subscription-details]');
    var config = getConfig(section);

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var purchase = card.getAttribute('data-purchase');

        cards.forEach(function (item) {
          item.classList.toggle('is-active', item === card);
        });

        if (subscriptionDetails) {
          subscriptionDetails.hidden = purchase !== 'subscription';
        }

        if (onetimeDetails) {
          onetimeDetails.hidden = purchase !== 'onetime';
        }

        if (sellingPlanInput) {
          if (purchase === 'subscription' && config.sellingPlanId) {
            sellingPlanInput.setAttribute('name', 'selling_plan');
            sellingPlanInput.value = config.sellingPlanId;
          } else {
            sellingPlanInput.removeAttribute('name');
          }
        }
      });
    });
  }

  function initQuantity(section) {
    var wrapper = section.querySelector('[data-cbb-qty]');
    var input = section.querySelector('[data-cbb-quantity-input]');
    var value = section.querySelector('[data-cbb-qty-value]');
    var minus = section.querySelector('[data-cbb-qty-minus]');
    var plus = section.querySelector('[data-cbb-qty-plus]');

    if (!wrapper || !input || !value || !minus || !plus) return;

    function setQty(nextQty) {
      var qty = parseInt(nextQty, 10);

      if (Number.isNaN(qty) || qty < 1) {
        qty = 1;
      }

      input.value = String(qty);
      value.textContent = String(qty);
    }

    minus.addEventListener('click', function () {
      setQty(parseInt(input.value, 10) - 1);
    });

    plus.addEventListener('click', function () {
      setQty(parseInt(input.value, 10) + 1);
    });
  }

  function initGallery(section) {
    var stage = section.querySelector('[data-cbb-stage]');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-cbb-thumb]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-cbb-dot]'));

    if (!stage) return;

    var mainImage = stage.querySelector('.codex-buy-box-test__main-image');
    var activeCount = Math.max(thumbs.length, 1);
    var activeIndex = 0;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var pointerCurrentX = 0;
    var pointerCurrentY = 0;
    var isPointerDown = false;
    var didSwipe = false;
    var swipeThreshold = 44;
    var verticalTolerance = 1.25;

    dots.forEach(function (dot, index) {
      dot.hidden = index >= activeCount;
    });

    function setActive(index) {
      activeIndex = normalizeIndex(index, activeCount);
      index = activeIndex;

      var thumb = thumbs[index];

      if (thumb && mainImage) {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';

        if (full) {
          mainImage.src = full;
          mainImage.removeAttribute('srcset');
          mainImage.alt = alt;
        }
      }

      thumbs.forEach(function (item, itemIndex) {
        var isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      dots.forEach(function (item, itemIndex) {
        var isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setActive(index % activeCount);
      });
    });

    function normalizeIndex(index, total) {
      if (!total) return 0;

      return ((index % total) + total) % total;
    }

    function goToOffset(offset) {
      setActive(activeIndex + offset);
    }

    function onPointerDown(event) {
      if (activeCount < 2) return;

      isPointerDown = true;
      didSwipe = false;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerCurrentX = pointerStartX;
      pointerCurrentY = pointerStartY;
      stage.classList.add('is-dragging');

      if (stage.setPointerCapture && event.pointerId !== undefined) {
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function onPointerMove(event) {
      if (!isPointerDown) return;

      pointerCurrentX = event.clientX;
      pointerCurrentY = event.clientY;
    }

    function onPointerUp(event) {
      if (!isPointerDown) return;

      pointerCurrentX = event.clientX;
      pointerCurrentY = event.clientY;
      isPointerDown = false;
      stage.classList.remove('is-dragging');

      var deltaX = pointerCurrentX - pointerStartX;
      var deltaY = pointerCurrentY - pointerStartY;
      var isMostlyHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * verticalTolerance;

      if (Math.abs(deltaX) >= swipeThreshold && isMostlyHorizontal) {
        didSwipe = true;
        goToOffset(deltaX < 0 ? 1 : -1);
      }
    }

    function onPointerCancel() {
      isPointerDown = false;
      stage.classList.remove('is-dragging');
    }

    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerCancel);
    stage.addEventListener('pointerleave', onPointerCancel);
    stage.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    stage.addEventListener('click', function (event) {
      if (!didSwipe) return;

      event.preventDefault();
      didSwipe = false;
    });
  }

  function initForm(section) {
    var form = section.querySelector('[data-cbb-form]');

    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submit(section, form);
    });
  }

  function initSticky(section) {
    var stickyButton = section.querySelector('[data-cbb-sticky-button]');
    var submitButton = section.querySelector('[data-cbb-submit]');

    if (!stickyButton || !submitButton) return;

    stickyButton.addEventListener('click', function () {
      submitButton.click();
    });
  }

  function submit(section, form) {
    var config = getConfig(section);
    var status = section.querySelector('[data-cbb-status]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-cbb-submit], [data-cbb-sticky-button]'));
    var variantInput = form.querySelector('input[name="id"]');
    var originalLabels = buttons.map(function (button) {
      return button.textContent;
    });

    if (!variantInput || !variantInput.value) {
      setStatus(status, 'Select a product or variant in the section settings.');
      return;
    }

    applyBogoUrlParams(section);

    setLoading(buttons, config.loadingText || 'Adding...');
    setStatus(status, '');

    var formData = new FormData(form);
    var activePurchase = section.querySelector('[data-cbb-purchase].is-active');

    if (activePurchase && activePurchase.getAttribute('data-purchase') === 'onetime') {
      formData.delete('selling_plan');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Unable to add item.');
          }

          return data;
        });
      })
      .then(function () {
        setStatus(status, config.successText || 'Added to cart.');
        redirectToCheckout(config);
      })
      .catch(function (error) {
        console.error('[Codex Buy Box Test] Add to cart error:', error);
        setStatus(status, config.errorText || 'Unable to add right now. Please try again.');
        resetButtons(buttons, originalLabels);
      });
  }

  function setLoading(buttons, label) {
    buttons.forEach(function (button) {
      button.classList.add('is-loading');
      button.disabled = true;
      button.textContent = label;
    });
  }

  function resetButtons(buttons, labels) {
    buttons.forEach(function (button, index) {
      button.classList.remove('is-loading');
      button.disabled = false;

      if (labels[index]) {
        button.textContent = labels[index];
      }
    });
  }

  function setStatus(status, message) {
    if (!status) return;

    status.textContent = message || '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
